/**
 * Nhận diện sàn từ link user dán vào trang "Rải link lụm tiền" + metadata hiển thị.
 *
 * Giữ song song với mobile/src/modules/link-converter/utils/detect-platform.ts —
 * hai bên lệch nhau nghĩa là cùng một link cho ra kết quả khác nhau tuỳ thiết bị.
 */

export function detectPlatform(url) {
    if (!url) return null;
    const lower = url.toLowerCase();
    // ShopeeFood xét TRƯỚC Shopee: link food cũng chứa chuỗi "shopee"
    if (
        lower.includes("shopeefood") ||
        lower.includes("spf.shopee.vn") ||
        lower.includes("now-food")
    )
        return "shopeefood";
    if (
        lower.includes("shopee") ||
        lower.includes("s.shopee.vn") ||
        lower.includes("shp.ee") ||
        lower.includes("shope.ee")
    )
        return "shopee";
    if (lower.includes("lazada") || lower.includes("lzd.co")) return "lazada";
    // TikTok Shop: link đầy đủ tiktok.com + short link vt./vm.tiktok.com
    if (lower.includes("tiktok.com")) return "tiktok";
    return null;
}

/**
 * Bóc link http(s) đầu tiên ra khỏi đoạn text dán vào.
 *
 * Nút "Sao chép liên kết" của TikTok Shop (và app Shopee/Lazada khi chia sẻ) copy
 * CẢ CÂU kèm tên sản phẩm. Gửi nguyên cả câu lên API thì backend `new URL()` fail
 * → user nhận lỗi "link không hợp lệ" dù họ dán đúng thứ sàn đưa.
 */
export function extractFirstUrl(text) {
    const match = String(text ?? "").match(/https?:\/\/[^\s"'<>()]+/i);
    // Dấu câu dính đuôi khi link nằm giữa câu ("...vt.tiktok.com/ZS9x/.")
    return match ? match[0].replace(/[.,;!?]+$/, "") : null;
}

/**
 * `requiresLogin`: API tạo link của sàn lấy userId từ session nên guest không lấy
 * link được — nhưng vẫn cho xem hoa hồng trước (endpoint thông tin SP là public).
 */
export const PLATFORM_INFO = {
    shopee: {
        name: "Shopee",
        logo: "/img/brand-logo/logo-shopee-200.png",
        textColor: "text-orange-600",
        bgColor: "bg-orange-50",
        borderColor: "border-orange-300",
        buttonColor: "bg-[#EE4D2D] hover:bg-[#d8431f]",
    },
    shopeefood: {
        name: "ShopeeFood",
        logo: "/img/brand-logo/logo-shopeefood-200.png",
        textColor: "text-orange-600",
        bgColor: "bg-orange-50",
        borderColor: "border-orange-300",
        buttonColor: "bg-[#FF7A00] hover:bg-[#e06c00]",
    },
    lazada: {
        name: "Lazada",
        logo: "/img/brand-logo/logo-lazada-200.png",
        textColor: "text-blue-600",
        bgColor: "bg-blue-50",
        borderColor: "border-blue-300",
        buttonColor: "bg-[#4760FF] hover:bg-[#3a50e0]",
    },
    tiktok: {
        name: "TikTok Shop",
        logo: "/img/brand-logo/logo-tiktok-shop-200.png",
        textColor: "text-pink-600",
        bgColor: "bg-pink-50",
        borderColor: "border-pink-300",
        buttonColor: "bg-[#FF3E64] hover:bg-[#e63555]",
        requiresLogin: true,
    },
};

export const SUPPORTED_PLATFORMS = ["shopee", "shopeefood", "lazada", "tiktok"];
